module.exports = {"$schema":"http://iglucentral.com/schemas/com.snowplowanalytics.self-desc/schema/jsonschema/1-0-0#","self":{"vendor":"com.codecombat","name":"play_level_victory_modal_next_level","format":"jsonschema","version":"1-0-0"},"type":"object","properties":{"user":{"type":"string","pattern":"^[a-z0-9]{24}$","maxLength":24,"minLength":24},"levelSlug":{"type":"string","maxLength":128},"nextLevelSlug":{"type":"string"}},"required":["user","levelSlug"],"additionalProperties":false}


//////////////////
// WEBPACK FOOTER
// ./app/schemas/events/play_level_victory_modal_next_level.json
// module id = 561
// module chunks = 97